import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { Button, ButtonGroup, OverlayTrigger, Tooltip } from "react-bootstrap";

export const SeverityScaleProtocol = (props) => {

  return (
    <>
      <ButtonGroup className="w-100 project-task-btn-group">
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-top">{"Critical"}</Tooltip>}
        >
          <Button
            className={`${props.severity === "Critical" ? "btn-active" : ""}`}
            variant="outline-dark"
            onClick={() => props.setSeverity("Critical")}
          >
            <FontAwesomeIcon style={{ color: "#CE0000" }} icon={faArrowUp} />
          </Button>
        </OverlayTrigger>
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-top">{"Important"}</Tooltip>}
        >
          <Button
            className={`${props.severity === "Important" ? "btn-active" : ""}`}
            variant="outline-dark"
            onClick={() => props.setSeverity("Important")}
          >
            <FontAwesomeIcon style={{ color: "purple" }} icon={faArrowUp} />
          </Button>
        </OverlayTrigger>
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-top">{"Normal"}</Tooltip>}
        >
          <Button
            className={`${props.severity === "Normal" ? "btn-active" : ""}`}
            variant="outline-dark"
            onClick={() => props.setSeverity("Normal")}
          >
            <FontAwesomeIcon className="text-info" icon={faArrowUp} />
          </Button>
        </OverlayTrigger>
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-top">{"Minor"}</Tooltip>}
        >
          <Button
            className={`${props.severity === "Minor" ? "btn-active" : ""}`}
            variant="outline-dark"
            onClick={() => props.setSeverity("Minor")}
          >
            <FontAwesomeIcon className="text-warning" icon={faArrowDown} />
          </Button>
        </OverlayTrigger>
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-top">{"Low"}</Tooltip>}
        >
          <Button
            className={`${props.severity === "Low" ? "btn-active" : ""}`}
            variant="outline-dark"
            onClick={() => props.setSeverity("Low")}
          >
            <FontAwesomeIcon className="text-success" icon={faArrowDown} />
          </Button>
        </OverlayTrigger>
      </ButtonGroup>
    </>
  );
};

export const SeverityScale = (props) => {

  return (
    <>
      <ButtonGroup className="w-100 project-task-btn-group">
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-top">{"Critical"}</Tooltip>}
        >
          <Button
            className={`${props.severity === 1 ? "btn-active" : ""}`}
            variant="outline-dark"
            onClick={() => props.setSeverity(1)}
            disabled={props.viewOnly}
          >
            <FontAwesomeIcon style={{ color: "#CE0000" }} icon={faArrowUp} />
          </Button>
        </OverlayTrigger>
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-top">{"Important"}</Tooltip>}
        >
          <Button
            className={`${props.severity === 2 ? "btn-active" : ""}`}
            variant="outline-dark"
            onClick={() => props.setSeverity(2)}
            disabled={props.viewOnly}
          >
            <FontAwesomeIcon style={{ color: "purple" }} icon={faArrowUp} />
          </Button>
        </OverlayTrigger>
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-top">{"Normal"}</Tooltip>}
        >
          <Button
            className={`${props.severity === 3 ? "btn-active" : ""}`}
            variant="outline-dark"
            onClick={() => props.setSeverity(3)}
            disabled={props.viewOnly}
          >
            <FontAwesomeIcon className="text-info" icon={faArrowUp} />
          </Button>
        </OverlayTrigger>
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-top">{"Minor"}</Tooltip>}
        >
          <Button
            className={`${props.severity === 4 ? "btn-active" : ""}`}
            variant="outline-dark"
            onClick={() => props.setSeverity(4)}
            disabled={props.viewOnly}
          >
            <FontAwesomeIcon className="text-warning" icon={faArrowDown} />
          </Button>
        </OverlayTrigger>
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-top">{"Low"}</Tooltip>}
        >
          <Button
            className={`${props.severity === 40 ? "btn-active" : ""}`}
            variant="outline-dark"
            onClick={() => props.setSeverity(40)}
            disabled={props.viewOnly}
          >
            <FontAwesomeIcon className="text-success" icon={faArrowDown} />
          </Button>
        </OverlayTrigger>
      </ButtonGroup>
    </>
  );
};
